import { render } from "./StoryCommentItem.vue.js?vue&type=template&id=4bd6c05b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentItem.vue?vue&type=template&id=4bd6c05b"
import script from "./StoryCommentItem.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentItem.vue?vue&type=script&lang=js"
export * from "./StoryCommentItem.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/story-comments/StoryCommentItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bd6c05b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bd6c05b', __exports__)) {
    api.reload('4bd6c05b', __exports__)
  }
  
  module.hot.accept("./StoryCommentItem.vue.js?vue&type=template&id=4bd6c05b!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentItem.vue?vue&type=template&id=4bd6c05b", () => {
    api.rerender('4bd6c05b', render)
  })

}


export default __exports__